import React from 'react';

function Header() {
  return (
    <header className="site-header">
      <div className="container">
        <div className="logo">
          <h1>HBFC Home Finance</h1>
        </div>
        <nav className="main-nav">
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#products">Loan Products</a></li>
            <li><a href="#calculator">Loan Calculator</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header; 